module.exports = __webpack_public_path__ + "assets/img/fsgc.ddc97a5d.png";